import HttpStatus from 'redpoints-connector-common/enumeration/HttpStatus';

import {
  FACILITATOR_VALIDATION_CLEAR,
  FACILITATOR_VALIDATION_DONE_ERROR,
  FACILITATOR_VALIDATION_FETCH_NEXT_LINK_TASK_REQUEST_REQUEST,
  FACILITATOR_VALIDATION_SET_CONTENT_LINK_URLS,
} from '../../../../actions/actionTypes';
import { TASK_KEY } from '../../../../services/FacilitatorValidationService';

const defaultState = null;

const contentLinkUrls = (state = defaultState, action) => {
  switch (action.type) {
    case FACILITATOR_VALIDATION_CLEAR:
    case FACILITATOR_VALIDATION_FETCH_NEXT_LINK_TASK_REQUEST_REQUEST:
      return defaultState;

    case FACILITATOR_VALIDATION_SET_CONTENT_LINK_URLS:
      return action.payload.contentLinkUrls ?? null;

    case FACILITATOR_VALIDATION_DONE_ERROR: {
      const allResponses = action.payload.response.data ?? {};

      const failedUrls = [];

      for (const key in allResponses) {
        if (
          allResponses[key].key !== TASK_KEY &&
          allResponses[key].status !== HttpStatus.CREATED.value
        ) {
          failedUrls.push(allResponses[key].key);
        }
      }

      return failedUrls.join('\n');
    }

    default:
      return state;
  }
};

export default contentLinkUrls;
